import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConfirmDialog } from "../../admin/components/shared/ConfirmDialog";
import AppToast from "../../../shared/components/AppToast";
import usePageManager from "../hooks/usePageManager";
import PageSidebar from "../components/PageSidebar";
import PageEditorForm from "../components/PageEditorForm";
import TemplateDialog from "../components/TemplateDialog";
import PreviewDialog from "../components/PreviewDialog";
import WelcomeState from "../components/WelcomeState";
import "../styles/admin-paginas.css";

const AdminPaginas = () => {
    const navigate = useNavigate();
    const pm = usePageManager();
    const [confirmVisible, setConfirmVisible] = useState(false);

    const confirmDelete = () => {
        setConfirmVisible(true);
    };

    return (
        <div className="landing-container">
            <AppToast ref={pm.toast} />
            <ConfirmDialog
                visible={confirmVisible}
                header="Confirmar eliminación"
                message={`¿Estás seguro de eliminar "${pm.navLabel || pm.title || pm.selectedSlug}"? Esta acción no se puede deshacer.`}
                acceptLabel="Eliminar"
                rejectLabel="Cancelar"
                acceptClassName="p-button-danger"
                onCancel={() => setConfirmVisible(false)}
                onConfirm={async () => {
                    setConfirmVisible(false);
                    await pm.handleDelete();
                }}
            />

            <TemplateDialog
                visible={pm.templateDialogVisible}
                onHide={() => pm.setTemplateDialogVisible(false)}
                onSelect={pm.applyTemplate}
            />

            <PreviewDialog
                visible={pm.previewDialogVisible}
                onHide={() => pm.setPreviewDialogVisible(false)}
                title={pm.title}
                navLabel={pm.navLabel}
                sections={pm.sections}
                onConfirm={pm.executeSave}
            />

            <div className="admin-pages-grid">
                <PageSidebar
                    filteredPages={pm.filteredPages}
                    selectedSlug={pm.selectedSlug}
                    pagesSearch={pm.pagesSearch}
                    onSearchChange={pm.setPagesSearch}
                    onSelectPage={(slug) => { pm.setSelectedSlug(slug); pm.setFormVisible(true); }}
                    onNewPage={() => { pm.resetForm(); pm.setTemplateDialogVisible(true); }}
                    onBack={() => navigate("/mi-cuenta")}
                />

                <div style={{ maxHeight: "calc(100vh - 100px)", overflow: "auto" }}>
                    {pm.formVisible ? (
                        <PageEditorForm
                            slug={pm.slug} setSlug={pm.setSlug}
                            navLabel={pm.navLabel} setNavLabel={pm.setNavLabel}
                            title={pm.title} setTitle={pm.setTitle}
                            footerColumn={pm.footerColumn} setFooterColumn={pm.setFooterColumn}
                            footerColumnOptions={pm.footerColumnOptions}
                            isHome={pm.isHome} setIsHome={pm.setIsHome}
                            textOnly={pm.textOnly} setTextOnly={pm.setTextOnly}
                            autoSlug={pm.autoSlug} setAutoSlug={pm.setAutoSlug}
                            optionsExpanded={pm.optionsExpanded} setOptionsExpanded={pm.setOptionsExpanded}
                            newSectionType={pm.newSectionType} setNewSectionType={pm.setNewSectionType}
                            sections={pm.sections} setSections={pm.setSections}
                            selectedSlug={pm.selectedSlug} loading={pm.loading}
                            pages={pm.pages} landingId={pm.landingId}
                            upsertPageConfig={pm.upsertPageConfig}
                            updateSection={pm.updateSection}
                            removeSection={pm.removeSection}
                            addStructuredLine={pm.addStructuredLine}
                            editStructuredLine={pm.editStructuredLine}
                            cancelEdit={pm.cancelEdit}
                            removeStructuredLine={pm.removeStructuredLine}
                            editingIndex={pm.editingIndex}
                            applySimpleTextFormat={pm.applySimpleTextFormat}
                            setTextEditorRef={pm.setTextEditorRef}
                            onSave={pm.handleSave}
                            onDelete={confirmDelete}
                        />
                    ) : (
                        <WelcomeState />
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminPaginas;
